/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceVisibilityResponse {
    getFixupPrototypeFunction() { return ComplianceVisibilityResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceVisibilityResponse>): ComplianceVisibilityResponse {
        let obj = Object.assign(new ComplianceVisibilityResponse(), model);
        ComplianceVisibilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceVisibilityResponse>): ComplianceVisibilityResponse {
        if (!model) return null;
        return ComplianceVisibilityResponse.newInstance(<ComplianceVisibilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceVisibilityResponse) {
        if (!obj) return;

        models.ComplianceVisibilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceVisibilityResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceVisibilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * list of visibility summary.
     */
    data: any;

}
